<script lang="ts">
  // What requests are waiting on, said in one place: the server learning
  // the App's installations (503 `installations_pending`, retried by
  // `api`), and the user's writes held through a rate-limit pause until it
  // ends (`github.onHeld`). The live region is always present so screen
  // readers announce the change.
  import { onCheckingAccess } from '../api/http';
  import { github } from '../api/gh';
  import { shortTime } from '../api/rateLimit';

  let checking = $state(false);
  let heldUntil: number | null = $state(null);
  $effect(() => onCheckingAccess((c) => (checking = c)));
  $effect(() => github.onHeld((until) => (heldUntil = until)));
</script>

<div class="checking-access" class:shown={checking || heldUntil !== null} role="status" aria-live="polite">
  {#if heldUntil !== null}Waiting for GitHub's rate limit… sends at {shortTime(heldUntil)}{:else if checking}Checking access…{/if}
</div>

<style>
  .checking-access {
    position: fixed;
    left: 16px;
    bottom: 16px;
    z-index: 50;
    max-width: calc(100vw - 32px);
    padding: 6px 12px;
    border-radius: 30px;
    background: var(--surface);
    color: var(--muted);
    border: 1px solid var(--line);
    box-shadow: var(--shadow);
    font-size: 13px;
  }
  .checking-access:not(.shown) {
    display: none;
  }
</style>
